import { createApp } from 'vue'
import RedirectApp from './RedirectApp.vue'
import redirectRouter from './redirect-router'

createApp(RedirectApp).use(redirectRouter).mount('#app')